module.exports = __webpack_public_path__ + "static/media/promotional_10.a0c530ff.png";